<mat-form-field appearance="fill" >
  <mat-label>{{ 'components.email-verification.label' | translate }}</mat-label>
  <input matInput (input)="onAnswerChange($any($event).target.value)" />
  <button mat-icon-button matSuffix (click)="generateCode()" [matTooltip]="'components.email-verification.resend' | translate">
    <mat-icon>refresh</mat-icon>
  </button>
  <mat-hint>{{ 'components.email-verification.hint' | translate: { email: email } }}</mat-hint>
</mat-form-field>